import React from 'react';
import { withTracking } from '../../utils/tracking/tracking';

enum ETypographyColor {
	title = 'text-gray-100',
	text = 'text-gray-200',
	lightText = 'text-gray-300',
	inactiveText = 'text-gray-400',
	white = 'text-white',
	error = 'text-error',
}

export type TypographyColor = keyof typeof ETypographyColor;

enum ETypographyVariant {
	header = 'font-slab',
	title = 'font-bold',
	abstract = 'font-sans',
}

export type TypographyVariant = keyof typeof ETypographyVariant;

export enum ETypographySize {
	xs = 'text-xs',
	xsSm = 'text-xs md:text-sm',
	sm = 'text-sm',
	smBase = 'text-sm md:text-base',
	base = 'text-base',
	baseLg = 'text-base md:text-lg',
	lg = 'text-lg md:text-xl',
	lgEven = 'text-lg',
	xl = 'text-xl md:text-2xl',
	xl3xl = 'text-xl md:text-3xl',
	xlSpace = 'text-xlSpace md:text-2xlSpace',
	xlEven = 'text-xl',
	xxl = 'text-2xl md:text-3xl',
	xxlEven = 'text-2xl',
	xxxlEven = 'text-3xl',
	'4xl' = 'text-4xl',
	'h3' = 'text-2xl md:text-6xl',
	'h2' = 'text-4xl md:text-7xl',
	'h1' = 'text-7xl',
}

export type TypographySize = keyof typeof ETypographySize;

interface ITypographyProps {
	children: React.ReactNode;
	component?: keyof JSX.IntrinsicElements;
	className?: string;
	href?: string;
	variant?: TypographyVariant;
	size?: TypographySize;
	color?: TypographyColor;
	onClick?: (e: React.MouseEvent) => void;
}

const TypographyComponent = ({
	children,
	component: Component = 'span',
	className = '',
	variant = 'abstract',
	size = 'base',
	color = 'text',
	href,
	onClick,
	...other
}: ITypographyProps) => {
	return (
		<Component
			{...other}
			href={href}
			target={Component === 'a' ? '_blank' : undefined}
			className={`${ETypographyVariant[variant]} ${ETypographySize[size]} ${ETypographyColor[color]} ${className} m-0`}
			onClick={onClick}>
			{children}
		</Component>
	);
};

export const Typography = withTracking(TypographyComponent);
